<template>
  <div id="app">
    <div id='step1' v-if='currentStep == 1'>
      <img src="../images/logo.png" alt="" class='logo'>
      <h1 class="main-title">{{ locale.events.title }}</h1>
      <h2>{{ locale.events.subtitle }}</h2>
      <div class="form-block">
        <div class="input-wrapper">
          <input type="text" v-model="nameEvent" :placeholder=locale.events.name_placeholder class="form-area" maxlength="179" @input="validateForm">
          <span class="input-line"></span>
        </div>
        <div class="input-wrapper">
          <input type="text" v-model="themeEvent" :placeholder=locale.events.theme_placeholder class="form-area" maxlength="270"  @input="validateForm">
          <span class="input-line"></span>
        </div>
        <div class="input-wrapper">
          <input type="text" v-model="placeEvent" :placeholder=locale.events.place_placeholder class="form-area" maxlength="65"  @input="validateForm">
          <span class="input-line"></span>
        </div>
        <div class="input-wrapper">
          <input type="text" v-model="dataEvent" :placeholder=locale.events.date_placeholder class="form-area" maxlength="65" @input="validateForm">
          <span class="input-line"></span>
        </div>
        <div class="input-wrapper">
          <input type="text" v-model="managerEvent" :placeholder=locale.events.manager_placeholder class="form-area" maxlength="42" @input="validateForm">
          <span class="input-line"></span>
        </div>
        <div class="input-wrapper">
          <input 
            type="text"
            v-model="phoneEvent"
            :placeholder=locale.events.phone_placeholder
            v-mask="phoneMask"
            class="form-area"
            @input="validateForm"
          >
          <span class="input-line"></span>
        </div>
      </div>
      <div class="checkboxs">
        <div class="checkbox-wrapper">
        <label class="checkbox-label">
          <input type="checkbox" class="checkbox-hidden" v-model="checkbox1" @change="validateForm">
          <span class="checkbox-mark"></span>
          <span class="checkbox-text" v-if="['uz', 'az', 'kz'].includes(lang)"><a href="/docs/event/Политика конфиденциальности ООО «Биннофарм Групп» event.pdf" target="_blank">{{ locale.events.checkbox1_link }}</a> {{ locale.events.checkbox2_text }}</span>
          <span class="checkbox-text" v-else>{{ locale.events.checkbox1_text }} <a href="/docs/event/Политика конфиденциальности ООО «Биннофарм Групп» event.pdf" target="_blank">{{ locale.events.checkbox1_link }}</a></span>
        </label>
        </div>
        <div class="checkbox-wrapper">
          <label class="checkbox-label">
            <input type="checkbox" class="checkbox-hidden" v-model="checkbox2" @change="validateForm">
            <span class="checkbox-mark"></span>
            <span class="checkbox-text" v-if="['uz', 'az', 'kz'].includes(lang)"><a :href="links[lang] || links['ru']" target="_blank">{{ locale.events.checkbox2_link }}</a> {{ locale.events.checkbox2_text }}</span>
            <span class="checkbox-text" v-else>{{ locale.events.checkbox2_text }} <a :href="links[lang] || links['ru']" target="_blank">{{ locale.events.checkbox2_link }}</a></span>
          </label>
        </div>
      </div>
      <div class='button-wrapper'>
          <button class='btn' @click.prevent='NextStep' :disabled="!isInputValid">{{ locale.ready }}</button>
        </div>
      <a class="prevBtn" href="../postcard">
        <img src="../images/prevBtn.svg" alt="">
        {{ locale.back }}
      </a>
    </div>
    <div id='step2' v-if='currentStep == 2'>
      <div class='header'>
        <div>
          <img src="../images/logo.png" alt="" class='logo' @click='repeat'>
        </div>
        <a @click.prevent='showInstruction'>
          <img src='../images/help.svg' class='help' @click='showInstruction'>
        </a>
      </div>
      <div>
        <h1 class="main-title">{{ locale.events.steps_title }}</h1>
      </div>
      <div class='template content' ref="content">
        <img :src="templates[lang]" alt="">
        <div class="name-before">{{ formattedNameEvent }}</div>
        <div :class="['name-fixed', lang]">{{ nameEvent }}</div>
        <div :class="['decription-fixed theme', lang]">{{ themeEvent }}</div>
        <div :class="['decription-fixed place', lang]">{{ placeEvent }}</div>
        <div :class="['decription-fixed data', lang]">{{ dataEvent }}</div>
        <div :class="['decription-fixed contacts', lang]">
          <div class="manager">{{ managerEvent }}</div>
          <div>{{ phoneEvent }}</div>
        </div>
      </div>
      <template v-if='!isGenerating'>
        <div class='buttons'>
          <button class='btn' @click.prevent='generateImage' v-if='!isGenerating'>{{ locale.ready }}</button>
          <button class='btn' disabled v-else>{{ locale.ready_disabled }}</button>

          <button class='btn' @click.prevent='anotherName'>
            {{ locale.events.step2_btn }}
          </button>
        </div>
      </template>

      <div class='preloader preloader--gradient' v-else>
        <div><span></span></div>
        <div><span></span></div>
        <div><span></span></div>
        
        <div><span></span></div>
        <div><span></span></div>
        <div><span></span></div>
        
        <div><span></span></div>
        <div><span></span></div>
        <div><span></span></div>
      </div>
      <button type="button" class="prevBtn" @click.prevent='prevStep'>
        <img src="../images/prevBtn.svg" alt="">
        {{ locale.back }}
      </button>
    </div>
    <div id='step3' v-if='currentStep == 3'>
      <div class='header'>
        <div>
          <img src="../images/logo.png" alt="" class='logo' @click='repeat'>
        </div>
        <a @click.prevent='showInstruction'>
          <img src='../images/help.svg' class='help' @click='showInstruction'>
        </a>
      </div>
      <div>
        <h1 class="main-title">{{ locale.events.steps_title }}</h1>
      </div>
      <div class='content'>
        <h3>{{ locale.events.step3_title }}</h3>
        <viewer :images='[generatedImage]' :options='viewerOptions'>
          <img :src="generatedImage" class='result'>
        </viewer>
        <div class='buttons'>
          <a @click.prevent='showPrintInstruction' class="print-instruction-btn">
            {{ locale.print_instruction }} <img src='../images/help.svg' class='help' @click='showPrintInstruction'>
          </a>
          <a class='btn' @click.prevent='download'>{{ locale.download }}</a>
          <button class='btn' v-if="webShareApiSupported" @click.prevent='shareResult'>{{locale.share }}<sup>*</sup></button>
          <a href='#' @click.prevent='repeatName' class='btn orange'> {{ locale.events.step3_btn }}</a>
          <a href='#' @click.prevent='repeat' class='repeat'>{{ locale.repeat }}</a>
        </div>

        <div class='hint' v-if="webShareApiSupported">
          <sup>*</sup> {{ locale.hint }}
        </div>
      </div>
    </div>
    <modal name="instruction" :adaptive='true' :scrollable='true' :height="'auto'">
      <a class='modal-close' @click.prevent='hideInstruction'>&times;</a>
      <div class='modal-content'>
        <center><span class="modal-title">{{ locale.instruction.title }}</span></center>
        <p>{{ locale.instruction.subtitle }}</p>
        <ol>
          <li>{{ locale.instruction.p1 }} <b>&laquo;{{ locale.step1_placeholder }}&raquo;</b>.</li>
          <li>{{ locale.instruction.p2 }} <b>&laquo;{{ locale.step2_name }}&raquo;</b>.</li>
          <li>{{ locale.instruction.p3 }} <b>&laquo;{{ locale.ready }}&raquo;</b>.</li>
          <li>{{ locale.instruction.p4 }}</li>
          <li>{{ locale.instruction.p5 }} <b>&laquo;{{ locale.download }}&raquo;</b>.</li>
          <li>{{ locale.instruction.p6 }} <b>&laquo;{{ locale.share }}&raquo;</b> <i>{{ locale.instruction.p_hooks }}</i>.</li>
          <li>{{ locale.instruction.p7 }} <b>&laquo;{{ locale.repeat }}&raquo;</b></li>
        </ol>
        <center>
          <b>
            <p>{{ locale.modal.footer }}</p>
          </b>
        </center>
        <a href='#' @click.prevent='hideInstruction'>{{ locale.modal.btn }}</a>
      </div>
    </modal>

    <modal name="printInstruction" :adaptive='true' :scrollable='true' :height="'auto'">
      <a class='modal-close' @click.prevent='hidePrintInstruction'>&times;</a>
      <div class='modal-content'>
        <center><span class="modal-title">{{ locale.print.title }}</span></center>
        <p><strong><u>{{ locale.print.desktop }}</u></strong> {{ locale.print.p1 }}</p>
        <p><strong><u>{{ locale.print.mobile }}</u></strong> {{ locale.print.p2 }}</p>
        <p>{{ locale.print.p3 }}</p>
        <center>
          <b>
            <p>{{ locale.modal.footer }}</p>
          </b>
        </center>
        <a href='#' @click.prevent='hidePrintInstruction'>{{ locale.modal.btn }}</a>
      </div>
    </modal>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import downloadjs from 'downloadjs';
import 'normalize.css';
import 'viewerjs/dist/viewer.css';
import 'vue-js-modal/dist/styles.css';
import { localCards } from '../locales/localCards.js';
import { getLangFromURL } from '../utils/utils.js';

export default {
  data: function () {
    const lang = getLangFromURL();
    const locale = localCards[lang] || localCards['ru'];

    return {
      lang,
      locale,
      templates: {
        ru: require('../images/event/event-template-ru.png'),
        am: require('../images/event/event-template-am.png'),
        kz: require('../images/event/event-template-kz.png'),
        uz: require('../images/event/event-template-uz.png'),
        ge: require('../images/event/event-template-ge.png'),
        md: require('../images/event/event-template-md.png'),
        az: require('../images/event/event-template-az.png'),
        ro: require('../images/event/event-template-ro.png'),
      },
      links: {
        ru: '/docs/event/RU Согласие на обработку ПД ООО «Биннофарм Групп».pdf',
        uz: '/docs/event/UZ Согласие на обработку ПД ООО «Биннофарм Групп».pdf',
        ro: '/docs/event/ROM Согласие на обработку ПД ООО «Биннофарм Групп».pdf',
      },
      currentStep: 1,
      nameEvent:'',
      themeEvent:'',
      placeEvent:'',
      dataEvent:'',
      managerEvent:'',
      phoneEvent:'',
      checkbox1: false,
      checkbox2: false,
      isInputValid: false,
      generatedImage: null,
      isGenerating: false,
      viewerOptions: { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": false, "tooltip": false, "movable": false, "zoomable": true, "rotatable": false, "scalable": false, "transition": false, "fullscreen": false, "keyboard": false }
    }
  },
  methods: {
    anotherName: function(_event) {
      this.currentStep = 1;
      this.nameEvent = '';
      this.themeEvent = '';
      this.placeEvent = '';
      this.dataEvent = '';
      this.managerEvent = '';
      this.phoneEvent = '';
      this.checkbox1 = false;
      this.checkbox2 = false;
      this.isInputValid = false;
      if (this.$metrika) this.$metrika.reachGoal('ANOTHER_NAME_23');
    },
    prevStep: function(_event) {
      this.currentStep -= 1;
    },
    validateForm: function() {
      this.isInputValid =
        this.nameEvent.trim().length > 0 &&
        this.themeEvent.trim().length > 0 &&
        this.placeEvent.trim().length > 0 &&
        this.dataEvent.trim().length > 0 &&
        this.managerEvent.trim().length > 0 &&
        this.phoneEvent.trim().length > 0 &&
        this.checkbox1 &&
        this.checkbox2;
    },
    NextStep: function(_event) {
      if (this.isInputValid) {
        this.currentStep = 2;
      }
      if (this.$metrika) this.$metrika.reachGoal('NEXT_STEP_23');
    },
    async generateImage() {
      this.isGenerating = true;

      const element = this.$refs.content;
      element.classList.add('gap');

      try {
        const canvas = await html2canvas(element, {
          scale: 4,
        });
        const dataURL = canvas.toDataURL('image/png');
      
        this.generatedImage = dataURL;
      } finally {
        this.currentStep = 3;
        this.isGenerating = false;
      }
      if (this.$metrika) this.$metrika.reachGoal('GENERATE_IMAGE_23');
    },
    shareResult: async function() {
      const response = await fetch(this.generatedImage);
      const blob = await response.blob();
      const file = new File([blob], 'event.png', { type: blob.type });
      await navigator.share({
        title: this.locale.events.share,
        files: [file],
      });
      if (this.$metrika) this.$metrika.reachGoal('SHARE_RESULT_23');
    },
    repeat: function() {
      this.currentStep = 1;
      this.nameEvent = '';
      this.themeEvent = '';
      this.placeEvent = '';
      this.dataEvent = '';
      this.managerEvent = '';
      this.phoneEvent = '';
      this.checkbox1 = false;
      this.checkbox2 = false;
      this.isInputValid = false;
      this.generatedImage = null;
      if (this.$metrika) this.$metrika.reachGoal('REPEAT_23');
    },
    repeatName: function() {
      this.currentStep = 1;
      this.nameEvent = '';
      this.checkbox1 = false;
      this.checkbox2 = false;
      this.isInputValid = false;
      this.generatedImage = null;
      if (this.$metrika) this.$metrika.reachGoal('REPEAT_23');
    },
    download: function() {
      if (this.$metrika) this.$metrika.reachGoal('DOWNLOAD_23');
      downloadjs(this.generatedImage, 'event.png', 'image/png');
    },
    showInstruction() {
      this.$modal.show('instruction');
    },
    hideInstruction() {
      this.$modal.hide('instruction')
    },

    showPrintInstruction() {
      this.$modal.show('printInstruction');
    },
    hidePrintInstruction() {
      this.$modal.hide('printInstruction')
    },
  }, 
  computed: {
    webShareApiSupported: function() {
      return navigator.canShare
    },
    formattedNameEvent() {
      if (!this.nameEvent) return '';

      const lang = getLangFromURL();
      const lastChar = this.nameEvent.trim().slice(-1).toLowerCase();

      if (lang === 'ru') {
        if (['а', 'я'].includes(lastChar)) {
          return 'Уважаемая,';
        } else {
          return 'Уважаемый,';
        }
      } else {
        return '';
      }
    },
    phoneMask() {
      const masks = {
        ru: '+7 (###) ###-##-##',
        am: '+374 (##) ##-##-##',
        kz: '+7 (###) ###-##-##',
        uz: '+998 (##) ###-##-##',
        ge: '+995 (###) ###-###',
        md: '+373 (##) ##-##-##',
        az: '+994 (##) ###-##-##',
        ro: '+40 (###) ###-###',
      };

      return masks[this.lang] || masks['ru'];
    }
  }
}
</script>

<style scoped lang='scss'>
#app {
  font-family: Gilroy;
  height: 100%;
}

h1, h2 {
    margin: 0;
  }

  h2 {
    font-size: 50px;
    line-height: 59px;
    color: #1758A8;

    @media (max-width: 992px) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  h1 {
    font-size: 64px;
    line-height: 78px;

    @media (max-width: 992px) {
      font-size: 30px;
      line-height: 38px;
    }
  }

#step1 {
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 50px 50px 50px;

  height: 100%;

  @media (max-width: 992px) {
    padding: 20px 20px 50px;
    height: unset;
  }

  .logo {
    width: 258px;
    padding-bottom: 60px;

    @media (max-width: 992px) {
      width: 189px;
    }
  }

  .main-title {
    margin-bottom: 50px;

    @media (max-width: 992px) {
      margin-bottom: 25px;
    }
  }

  .uploadBtn {
    margin-top: 69px;

    width: 311px;
    height: 78.5px;

    background: #FFFFFF;
    border: 2px solid #4A7EBD;
    box-sizing: border-box;
    border-radius: 100px;

    display: flex;
    justify-content: center;
    align-items: center;

    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 31px;

    text-align: center;

    color: #4A7EBD;

    cursor: pointer;

    transition: color 0.5s ease-out, background-color 0.5s ease-out;
    
    svg {
      margin-right: 20px;
      transition: color 0.5s ease-out;
    }

    &:hover,
    &:focus-visible {
      background-color: #4A7EBD;
      color: white;
    }

    @media (max-width: 992px) {
      margin-top: 30px;

      width: 228px;
      height: 72px;

      font-size: 20px;
      line-height: 26px;
    }
  }

  .form-block {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    width: 100%;

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
    }
  }

  .input-wrapper {
    width: 100%;
    position: relative;
    max-width: 550px;

    @media (max-width: 992px) {
      max-width: 400px;
    }

    @media (max-width: 767px) {
      max-width: 320px;
    }
  }

  .form-area {
    margin-top: 60px;
    font-size: 28px;
    line-height: 58px;
    border: 0;
    width: 100%;
    height: 65px;
    border-bottom: 1px solid #DCDCDC;
    outline: none;
    resize: none;
    transition: border 0.5s ease-in-out;

    @media (max-width: 992px) {
      margin-top: 30px;
      font-size: 20px;
      height: 45px;
    }

    @media (max-width: 767px) {
      line-height: 34px;
      font-size: 16px;
      margin-top: 30px;
    }

    @media (max-width: 450px) {
      font-size: 14px;
    }

    &::placeholder {
      font-size: 28px;
      line-height: 58px;
      color: rgb(30, 30, 30);
      opacity: 0.8;

      @media (max-width: 992px) {
      font-size: 20px;
      }

      @media (max-width: 767px) {
        font-size: 16px;
      }

      @media (max-width: 450px) {
        font-size: 14px;
      }
    }

    & ~ .input-line {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 1px;
      background-color: #1758A8;
      transition: 0.4s;
    }

    &:focus-visible ~ .input-line {
      width: 100%;
      transition: 0.4s;
      left: 0;
    }
  }

  .checkboxs {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .checkbox-label {
    display: flex;
    gap: 10px;
    max-width: 550px;
    cursor: pointer;

    @media (max-width: 767px) {
      max-width: 320px;
    }
  }

  .checkbox-text {
    text-align: start;

    a {
      color: #1758A8;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .checkbox-mark {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-top: 2px;
    background-color: transparent;
    box-shadow: 0 0 5px 0 rgba(34, 60, 80, 0.2);
    border-radius: 6px;
    flex-shrink: 0;
  }

  .checkbox-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;
    white-space: nowrap;
    clip: rect(0 0 0 0);
    overflow: hidden;

    &[type='checkbox'] + .checkbox-mark::after {
      content: '';
      border-radius: 6px;
      opacity: 0;
      transform: scale(0.8);
      transition: background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease;
    }

    &[type='checkbox']:checked + .checkbox-mark {
      border: none;
    }

    &[type='checkbox']:checked + .checkbox-mark::after {
      width: 100%;
      height: 100%;
      background-image: url('../images/check.svg');
      background-repeat: no-repeat;
      background-size: 16px;
      background-position: center;
      background-color: #1758A8;
      opacity: 1;
      transform: scale(1);
    }
  }

  .button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    .btn {
      font-size: 20px;
      box-sizing: border-box;
      border: none;
      padding: 10px;
      background: #4A7EBD;
      cursor: pointer;
      color: white;
      margin-right: 10px;
      text-align: center;
      border-radius: 100px;
      width: 300px;
      height: 54px;
      transition: color 0.3s ease-out, background-color 0.3s ease-out, box-shadow 0.3s ease-out;
      &:last-child {
        margin-right: 0;
      }
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &:hover:not([disabled]),
      &:focus-visible:not([disabled]) {
        color: #4A7EBD;
        background-color: white;
        box-shadow: inset 0 0 0 1px #4A7EBD;
      }
    }

    @media (max-width: 992px) {
      flex-direction: column;
      margin-top: 30px;
      align-items: center;
      width: 100%;
      .btn {
        margin: 0 0 10px 0;
        font-size: 18px;
        padding: 10px;
        width: 180px;
        height: 45px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.prevBtn {
  position: fixed;
  right: 5%;
  bottom: 5%;
  padding: 15px 35px;
  margin: 0;
  border: 0;
  background-color: #D9D9D9;
  display: flex;
  gap: 8px;
  font-size: 20px;
  line-height: 24px;
  border-radius: 100px;
  text-decoration: none;
  color: black;

  @media (max-width: 992px) {
    position: unset;
    right: unset;
    bottom: unset;
    margin: 70px auto 0;
  }

  @media (max-width: 767px) {
    margin: 40px auto 0;
    font-size: 16px;
    line-height: 24px;
  }

  & img {
    transition: transform 0.3s ease-out;
  }

  &:hover {
    img {
      transform: translateX(-10px);
    }
  }
}

#step2, #step3 {
  padding: 30px;

  @media (max-width: 992px) {
    padding: 20px;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 40px;

    @media (max-width: 992px) {
      margin-bottom: 30px;
    }

    .logo {
      height: 65px;
      cursor: pointer;
    }

    .help {
      cursor: pointer;
    }
    
    @media (max-width: 992px) {
      .help {
        margin-right: 15px;
      }
    }
  }

  .main-title {
    margin: -60px 0 20px;
    text-align: center;

    @media (max-width: 992px) {
      margin: 20px 0 20px;
    } 
  }
}

#step2 {

  .range {
    max-width: 960px;
    width: 67%;
    margin: 0 auto;
  }
  
  .template {
    position: relative;
    width: 353px;
    height: 660px;
    margin: 0 auto 40px;
    font-size: 14px;
    line-height: 20px;

    &.gap {
      .name-before {
        top: 28.1%;
      }

      .name-fixed {
        &.ru {
          top: 31.3%;
        }

        &.am,
        &.uz,
        &.kz,
        &.ge,
        &.md,
        &.az,
        &.ro {
          top: 32.3%;
        }
      }

      .decription-fixed {
        &.theme {
          &.ru {
            top: 53.2%;
          }

          &.am {
            top: 55.1%;
          }

          &.uz {
            top: 56.1%;
          }

          &.kz {
            top: 55%;
          }

          &.ge {
            top: 54.7%;
          }

          &.md {
            top: 55.8%;
          }

          &.az {
            top: 55.4%;
          }

          &.ro {
            top: 55.9%;
          }
        }

        &.place {
          &.ru {
            top: 71.8%;
          }

          &.am {
            top: 71.3%;
          }

          &.uz {
            top: 72.2%;
          }

          &.kz {
            top: 71.4%;
          }

          &.ge {
            top: 70.8%;
          }

          &.md {
            top: 71.8%;
          }

          &.az {
            top: 71.5%;
          }

          &.ro {
            top: 72%;
          }
        }

        &.data {
          &.ru {
            top: 77.2%;
          }

          &.am {
            top: 76.7%;
          }

          &.uz {
            top: 77.6%;
          }

          &.kz {
            top: 76.8%;
          }

          &.ge {
            top: 76.2%;
          }

          &.md {
            top: 77.3%;
          }

          &.az {
            top: 76.9%;
          }

          &.ro {
            top: 77.4%;
          }
        }

        &.contacts {
          &.ru {
            top: 82.7%;
          }

          &.am {
            top: 82.2%;
          }

          &.uz {
            top: 82.9%;
          }

          &.kz {
            top: 82.2%;
          }

          &.ge {
            top: 81.6%;
          }

          &.md {
            top: 82.6%;
          }

          &.az {
            top: 82.2%;
          }

          &.ro {
            top: 82.8%;
          }
        }
      }
    }

    img {
      position: relative;
      max-width: 100%;
      min-height: 660px;
    }

    .name-before {
      position: absolute;
      color: #000;
      top: 29%;
      left: 20px;
      font-size: 16px;
    }

    .name-fixed {
      position: absolute;
      font-weight: 600;

      top: 32%;
      left: 20px;
      width: 285px;
      color: #000;

      &.ru {
        top: 32%;
      }

      &.am,
      &.uz,
      &.kz,
      &.ge,
      &.md,
      &.az,
      &.ro {
        top: 33%;
      }

      @media (max-width: 992px) {
        width: 268px;
      }
    }

    .decription-fixed {
      position: absolute;
      line-height: 18px;
      color: #435D70;
      left: 20px;
      width: 310px;

      &.theme {
        &.ru {
          text-indent: 40px;
          top: 54%;
        }

        &.am {
          text-indent: 50px;
          top: 56.1%;
        }

        &.uz {
          text-indent: 52px;
          top: 57%;
        }

        &.kz {
          text-indent: 71px;
          top: 55.8%;
        }

        &.ge {
          text-indent: 44px;
          top: 55.7%;
        }

        &.md {
          text-indent: 46px;
          top: 56.6%;
        }

        &.az {
          text-indent: 54px;
          top: 56.3%;
        }

        &.ro {
          text-indent: 44px;
          top: 56.7%;
        }
      }

      &.place {
        &.ru {
          text-indent: 50px;
          top: 72.8%;
        }

        &.am {
          text-indent: 45px;
          top: 72.2%;
        }

        &.uz {
          text-indent: 40px;
          top: 73.1%;
        }

        &.kz {
          text-indent: 92px;
          top: 72.3%;
        }

        &.ge {
          text-indent: 66px;
          top: 71.7%;
        }

        &.md {
          text-indent: 44px;
          top: 72.7%;
        }

        &.az {
          text-indent: 32px;
          top: 72.4%;
        }

        &.ro {
          text-indent: 44px;
          top: 72.8%;
        }
      }

      &.data {
        &.ru {
          text-indent: 98px;
          top: 78.2%;
        }

        &.am {
          text-indent: 165px;
          top: 77.6%;
        }

        &.uz {
          text-indent: 120px;
          top: 78.4%;
        }

        &.kz {
          text-indent: 123px;
          top: 77.6%;
        }

        &.ge {
          text-indent: 125px;
          top: 77.2%;
        }

        &.md {
          text-indent: 82px;
          top: 78.1%;
        }

        &.az {
          text-indent: 94px;
          top: 77.7%;
        }

        &.ro {
          text-indent: 78px;
          top: 78.2%;
        }
      }

      &.contacts {
        display: flex;
        gap: 5px;

        &.ru {
          top: 83.6%;

          .manager {
            text-indent: 110px;
          }
        }

        &.am {
          top: 83.1%;

          .manager {
            text-indent: 70px;
          }
        }

        &.uz {
          top: 83.8%;

          .manager {
            text-indent: 72px;
          }
        }

        &.kz {
          top: 83.1%;

          .manager {
            text-indent: 82px;
          }
        }

        &.ge {
          top: 82.5%;

          .manager {
            text-indent: 75px;
          }
        }

        &.md {
          top: 83.4%;

          .manager {
            text-indent: 70px;
          }
        }

        &.az {
          top: 83.1%;

          .manager {
            text-indent: 68px;
          }
        }

        &.ro {
          top: 83.6%;

          .manager {
            text-indent: 65px;
          }
        }
      }

      @media (max-width: 992px) {
        width: 292px;
      }
    }

    @media (max-width: 992px) {
      width: 335px;
    }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
    .btn {
      box-sizing: border-box;
      border: none;
      padding: 10px;
      background: #4A7EBD;
      cursor: pointer;
      color: white;
      margin-right: 10px;
      text-align: center;
      border-radius: 100px;
      width: 200px;
      transition: color 0.3s ease-out, background-color 0.3s ease-out, box-shadow 0.3s ease-out;
      &:last-child {
        margin-right: 0;
      }
      &:disabled {
        opacity: 0.5;
      }

      &:hover,
      &:focus-visible {
        color: #4A7EBD;
        background-color: white;
        box-shadow: inset 0 0 0 1px #4A7EBD;
      }
    }

    @media (max-width: 992px) {
      flex-direction: column;
      margin-top: 20px;
      align-items: center;
      width: 100%;
      .btn {
        margin: 0 0 10px 0;
        padding: 10px;
        width: 60%;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

#step3 {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  h3 {
    font-size: 36px;
    line-height: 46px;
    margin-top: 0;
    @media (max-width: 992px) {
      font-size: 20px;
      line-height: 25px;
    }
  }
  h4 {
    font-size: 36px;
    line-height: 46px;
    margin: 0 0 10px 0;
    text-align: center;
    @media (max-width: 992px) {
      font-size: 20px;
      line-height: 25px;
    }
  }
  img.result {
    margin-top: 50px;
    max-width: 250px;
    width: 100%;
    cursor: pointer;
  }
  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 40px;
    .btn {
      box-sizing: border-box;
      border: none;
      padding: 10px 10px;
      background-color: #4A7EBD;
      cursor: pointer;
      color: white;
      margin-bottom: 20px;
      text-align: center;
      text-decoration: none;
      border-radius: 100px;
      transition: color 0.3s ease-out, background-color 0.3s ease-out, box-shadow 0.3s ease-out;
      &.orange {
        background-color: #E85412;

        &:hover,
        &:focus-visible {
          color: #E85412;
          background-color: white;
          box-shadow: inset 0 0 0 1px #E85412;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }

      &:hover,
      &:focus-visible {
        color: #4A7EBD;
        background-color: white;
        box-shadow: inset 0 0 0 1px #4A7EBD;
      }
    }

    @media (max-width: 992px) {
      flex-direction: column;
      margin-top: 20px;
      align-items: center;
      width: 100%;
      .btn {
        margin: 0 0 10px 0;
        padding: 10px;
        width: 60%;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .repeat {
    position: relative;
    color: rgba(74, 126, 189, 1);
    text-align: center;
    text-decoration: none;
    max-width: 120px;
    margin: 0 auto;

    &:before {
      content: "";
      position: absolute;
      background-color: rgba(74, 126, 189, 1);
      left: 0;
      bottom: -3px;
      width: 0;
      height: 1px;
      transition: width 0.3s ease-in-out;
    }

    &:hover:before {
      width: 100%;
    }
  }
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  max-height: calc(100% - 40px);
  overflow-y: auto;
  text-align: justify;
  ol {
    padding-left: 20px;
  }
  a {
    display: block;
    text-align: center;
    color: rgba(74, 126, 189, 1);
  }
}

.hint {
  max-width: 450px;
  width: 90%;
  text-align: justify;
  opacity: 0.5;
  padding-top: 15px;
  font-size: 75%;
  &:before {
    content: '';
    display: block;
    width: 50px;
    height: 1px;
    background: black;
    margin-bottom: 5px;
  }
}

.modal-title {
  font-size: 42px;
  line-height: 68px;
  font-weight: 700;
}

.modal-close {
  cursor: pointer;
  position: absolute;
  font-size: 26px;
  line-height: 26px;
  width: 26px;
  padding: 5px;
  right: 10px;
  top: 10px;
  text-align: center;
  background: white;
  border-radius: 5px;
  border: 1px solid black;
}

$preloaderMainColor: #0053a6;
$preloaderSecondColor: #E85412;
$preloaderWidth: 55px;
$preloaderHeight: $preloaderWidth;
/*$preloaderAnimationDuration: 1.3s;
$preloaderAnimationDelay: 30; //ms*/
/* baidin */
$preloaderAnimationDuration: 1.7s;
$preloaderAnimationDelay: 150; //ms
/* series */
/*$preloaderAnimationDuration: .9s;
$preloaderAnimationDelay: 100; //ms*/

.preloader {
  width: $preloaderWidth;
  height: $preloaderHeight;
  margin: 20px auto;
  overflow: hidden;
  
  div {
    padding: 0;
    margin: 0;
    display: block;
    float: left;
    width: 27%;
    height: 27%;
    margin-right: 9%;
    margin-bottom: 9%;
    background-color: $preloaderMainColor;
    
    &:nth-child(3n){
      margin-right: 0;
    }
    
    span {
      display: block;
      height: 100%;
      width: 100%;
      opacity: 0;
      background-color: $preloaderSecondColor;
      content: '';
      animation-duration: $preloaderAnimationDuration;
      animation-iteration-count: infinite;
      animation-timing-function: ease;
    }
    
    @for $i from 1 through 9 {
      &:nth-child(#{$i}) {
        span{
          animation-delay: #{$i * $preloaderAnimationDelay}ms;
        }
      }
    }
  }
}

.preloader--gradient {
  // margin-left: calc($preloaderWidth / 2);
  div {
    span {
      animation-name: gradient;
    }
  }
}

.print-instruction-btn {
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
  align-items: center;
  cursor: pointer;
}

@keyframes gradient {
    0% {opacity: 0;}
    50% {opacity: 1;}
    100% {opacity: 0;}
}
</style>
